// extracted by mini-css-extract-plugin
module.exports = {"container":"StatsSatus_container__wlSzd","shape":"StatsSatus_shape__14xOa"};